import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class CompositionTypeService extends RestfulService<Models.CompositionType> {

  constructor(private restService: RestService) {
    super(Models.CompositionType);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('composition-types');
  }

}
